<script setup>
// 맵 기반 페이지 전용 세션 keep-alive 게이트 (DDAT-1660 — KR DDAT-104 포트).
// App.vue 의 v-if 로 mount/unmount 되어 composable singleton timer 를 토글한다.
// 본 sentinel 은 template 없음 — 순수 lifecycle 트리거 용도.
import { useMapSessionKeepAlive } from '@/composables/useMapSessionKeepAlive';
useMapSessionKeepAlive();
</script>

<template></template>
